"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildUrl = void 0;
const buildUrl = (baseUrl, urlParams) => {
    const url = new URL(baseUrl);
    for (const key in urlParams) {
        url.searchParams.append(key, String(urlParams[key]));
    }
    return url;
};
exports.buildUrl = buildUrl;
//# sourceMappingURL=buildUrl.js.map